import React, {Component} from 'react';
import {Translation} from 'react-i18next';

import CareGuideHelperTagForm from '../containers/CareGuideHelperTagFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';

class CareGuideHelperTagEditScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `CareGuideHelperTagEditScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    return (
      <Translation>{(t) => 
        <div>
          <DocumentHead title={t('care_guide_helper_tag_route_edit')} />
          <CareGuideHelperTagForm id={this.props.match.params.id} />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default CareGuideHelperTagEditScreen;

Logger.log('silly', `CareGuideHelperTagEditScreen loaded.`);
